import { useTranslation } from 'react-i18next';
import { ListPageLayout } from '@/components/templates';
import { ShippingRatesContainer } from '@/features/shipping/containers/shipping-rates-container';

export default function ShippingPage() {
  const { t } = useTranslation();

  return (
    <ListPageLayout title={t('shipping.title')}>
      <ShippingRatesContainer />
    </ListPageLayout>
  );
}
